<template>
  <el-form-item :label="labelText">
    <div id="custom-date" class="custom-date">
    </div>
  </el-form-item>
</template>

<script>

import _ from 'lodash'

// Date转化成字符串格式yyyy-MM-dd HH:mm:ss函数
Date.prototype.toMyStr = function () {
  var year = this.getFullYear()
  var month = this.getMonth() + 1
  var date = this.getDate()

  if (month < 10) {
    month = '0' + month
  }
  if (date < 10) {
    date = '0' + date
  }
  return year + '-' + month + '-' + date
}
function getNowTimesDay () {
  return new Date().toMyStr()
}

export default {
  name: 'customDate',
  props: {
    label: String,
    value: ''
  },
  data () {
    return {
    }
  },
  mounted: function () {
    this.renderDate()
  },
  methods: {
    renderDate: function () {
      const _this = this
      window.laydate.render({
        elem: '#custom-date',
        range: true,
        type: 'month',
        cycle: 'month',
        max: getNowTimesDay(),
        min: '2018-1-1',
        isShowDate: true,
        done: function (time, start, end, dateType) {
          let curDate = new Date()
          if (dateType === 'month' && end.month === (curDate.getMonth() + 1) && end.year === (curDate.getFullYear())) {
            end.date = curDate.getDate()
          }
          let startTime = `${start.year}-${window.lay.digit(start.month)}-${window.lay.digit(start.date)}`
          let endTime = `${end.year}-${window.lay.digit(end.month)}-${window.lay.digit(end.date)}`
          if (_.isEmpty(time)) {
            $(this.elem).text('')
            $(this.elem).removeAttr('data-starttime')
            $(this.elem).removeAttr('data-endtime')
            $(this.elem).removeAttr('data-datetype')
            startTime = ''
            endTime = ''
          } else {
            $(this.elem).text(`${startTime} - ${endTime}`)
            $(this.elem).attr('data-starttime', startTime)
            $(this.elem).attr('data-endtime', endTime)
            $(this.elem).attr('data-datetype', dateType)
          }
          _this.$emit('input', {
            startTime: startTime,
            endTime: endTime,
            dateType: dateType
          })
        }
      })
    },
    initDate: function (val) {
      const _this = this
      const existedDate = val
      const customData = $('#custom-date')
      customData.html(`${existedDate.startTime} - ${existedDate.endTime}`)
      customData.attr('data-starttime', existedDate.startTime)
      customData.attr('data-endtime', existedDate.endTime)
      customData.attr('data-datetype', existedDate.dateType)
      _this.$emit('input', existedDate)
    },
    clearDate: function () {
      const _this = this
      const initDate = this.$tool.getCurrentMonth()
      const customData = $('#custom-date')
      customData.html(`${initDate.startTime} - ${initDate.endTime}`)
      customData.attr('data-starttime', initDate.startTime)
      customData.attr('data-endtime', initDate.endTime)
      customData.attr('data-datetype', 'month')
      _this.$emit('input', initDate)
    }
  },
  computed: {
    labelText () {
      return this.label || this.$t('filters.date')
    }
  },
  watch: {
    value: function (val, oldVal) {
      this.initDate(val)
    }
  }
}
</script>

<style scoped lang="scss">
.custom-date{
  -webkit-appearance: none;
  background-color: #fff;
  background-image: none;
  border-radius: 4px;
  border: 1px solid #dcdfe6;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  color: #aaa;
  font-size: inherit;
  height: 40px;
  line-height: 40px;
  outline: 0;
  padding: 0 15px;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/topdoor/components/customDate.vue